// extracted by css-extract-rspack-plugin
export default {"ColorPill":"ChartSettingSegmentsEditor-module__ColorPill___za0kK","Table":"ChartSettingSegmentsEditor-module__Table___n5BGv"};